<!-- Begin Page Content -->
<div class="container-fluid">

  <!-- DataTales Example -->
  <div class="card bg-white shadow mb-4">
    <!-- <div class="card-header bg-white py-3">
      <h1 class="text-gray-800"  style="display: inline-block">Manage Element Manufacturer</h1>
      <button type="button" class="btn " style="float: right" [routerLink]="['/component','manufacturers','manuf-add']">
        Add Manufacturer
      </button>
    </div> -->
    <div class="card-body">
      <div class="table-responsive">
        <table datatable [dtOptions]="dtoptions" class="table table-bordered" width="100%"
          *ngIf="manufacturers && manufacturers.length > 0">
          <thead>
            <tr>
           
              <th>Name</th>
             
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let manufacturer of manufacturers">
             
              <td> <a style="color: black" 
                (click)="navigate(manufacturer.Id)"
                >{{ manufacturer.Name }}</a></td>
              
            </tr>
          </tbody>
        </table>
        <p *ngIf="!manufacturers || manufacturers.length <= 0">
          No Manufacturer Found !
        </p>
      </div>
    </div>
  </div>
</div>